var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cover',{attrs:{"productDetail":_vm.productDetail}}),_c('Jobs',{attrs:{"productDetail":_vm.productDetail}}),_c('Header',{on:{"click":_vm.changeDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }